import Marquee from "react-fast-marquee";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="border-t border-maroon/60 bg-[#0A0A0A]" data-testid="footer">
      <div className="h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" />
      <div className="py-8 border-b border-white/5 overflow-hidden">
        <Marquee speed={30} gradient={false}>
          {Array.from({ length: 6 }).map((_, i) => (
            <span key={i} className="flex items-center">
              <span className="font-serif text-3xl md:text-4xl font-light tracking-[0.25em] text-zinc-700 mx-8">
                VINCEN
              </span>
              <span className="w-2 h-2 bg-gold/40 rotate-45 mx-4" />
              <span className="text-xs tracking-[0.4em] uppercase text-zinc-600 mx-8">
                The One Who Conquers
              </span>
              <span className="w-2 h-2 bg-gold/40 rotate-45 mx-4" />
            </span>
          ))}
        </Marquee>
      </div>
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-12">
        <div>
          <p className="font-serif text-2xl tracking-[0.2em] text-[#F5F5F5]">VINCEN</p>
          <p className="mt-4 text-sm text-zinc-500 leading-relaxed max-w-xs">
            Luxury football collaborations. Where the pitch meets the atelier, the
            racetrack and the silver screen.
          </p>
        </div>
        <div>
          <p className="text-xs tracking-[0.35em] uppercase text-gold mb-6">Collections</p>
          <div className="flex flex-col gap-3">
            <Link to="/shop?collab=automobile" data-testid="footer-automobile-link" className="text-sm text-zinc-400 hover:text-gold transition-colors duration-300">
              Football &times; Automobile
            </Link>
            <Link to="/shop?collab=cinema" data-testid="footer-cinema-link" className="text-sm text-zinc-400 hover:text-gold transition-colors duration-300">
              Football &times; Cinema
            </Link>
            <Link to="/shop" data-testid="footer-all-link" className="text-sm text-zinc-400 hover:text-gold transition-colors duration-300">
              All Pieces
            </Link>
          </div>
        </div>
        <div>
          <p className="text-xs tracking-[0.35em] uppercase text-gold mb-6">Maison</p>
          <div className="flex flex-col gap-3">
            <Link to="/account" data-testid="footer-account-link" className="text-sm text-zinc-400 hover:text-gold transition-colors duration-300">
              My Account
            </Link>
            <Link to="/auth" data-testid="footer-auth-link" className="text-sm text-zinc-400 hover:text-gold transition-colors duration-300">
              Sign In
            </Link>
          </div>
        </div>
        <div>
          <p className="text-xs tracking-[0.35em] uppercase text-gold mb-6">Information</p>
          <div className="flex flex-col gap-3">
            <Link to="/about" data-testid="footer-about-link" className="text-sm text-zinc-400 hover:text-gold transition-colors duration-300">
              About Us
            </Link>
            <Link to="/privacy-policy" data-testid="footer-privacy-link" className="text-sm text-zinc-400 hover:text-gold transition-colors duration-300">
              Privacy Policy
            </Link>
            <Link to="/terms" data-testid="footer-terms-link" className="text-sm text-zinc-400 hover:text-gold transition-colors duration-300">
              Terms of Service
            </Link>
            <Link to="/returns" data-testid="footer-returns-link" className="text-sm text-zinc-400 hover:text-gold transition-colors duration-300">
              Returns &amp; Shipping
            </Link>
            <Link to="/size-guide" data-testid="footer-size-guide-link" className="text-sm text-zinc-400 hover:text-gold transition-colors duration-300">
              Size Guide
            </Link>
          </div>
        </div>
        <div>
          <p className="text-xs tracking-[0.35em] uppercase text-gold mb-6">Contact Us</p>
          <div className="flex flex-col gap-3">
            <a href="mailto:vinceninfo@gmail.com" data-testid="footer-email-link" className="text-sm text-zinc-400 hover:text-gold transition-colors duration-300">
              vinceninfo@gmail.com
            </a>
          </div>
        </div>
      </div>
      <div className="overflow-hidden select-none pointer-events-none px-4">
        <p className="text-center font-serif font-light leading-none text-[#F5F5F5]/[0.04] text-[23vw] md:text-[16vw] tracking-tight">
          VINCEN
        </p>
      </div>
      <div className="border-t border-white/5 py-6 text-center">
        <p className="text-xs tracking-[0.3em] uppercase text-zinc-600">
          &copy; 2026 Vincen &mdash; The One Who Conquers
        </p>
      </div>
    </footer>
  );
};

export default Footer;
